import {
  IconInbox,
  IconHeadset,
  IconSearch,
  IconChevronLeft,
  IconChevronRight,
} from "@tabler/icons-react";
import styles from "./TalentMessages.module.css";
import ThreadItem from "./ThreadItem";

export default function ThreadListPanel({
  currentInbox,
  onSwitchInbox,
  userCount,
  supportCount,
  searchQuery,
  onSearchChange,
  pagedThreads,
  selectedThreadId,
  onThreadClick,
  pageInfoText,
  currentPage,
  totalPages,
  onPrevPage,
  onNextPage,
  onGoPage,
}) {
  return (
    <div className={styles.msgPanel}>
      <div className={styles.msgPanelHeader}>
        <div className={styles.inboxTabs}>
          <button
            className={`${styles.inboxTab} ${currentInbox === "user" ? styles.inboxTabActive : ""}`}
            onClick={() => onSwitchInbox("user")}
          >
            <IconInbox size={15} /> User Inbox
            <span className={styles.tabBadge}>{userCount}</span>
          </button>
          <button
            className={`${styles.inboxTab} ${currentInbox === "support" ? styles.inboxTabActive : ""}`}
            onClick={() => onSwitchInbox("support")}
          >
            <IconHeadset size={15} /> Support
            <span className={styles.tabBadge}>{supportCount}</span>
          </button>
        </div>
        <div className={styles.msgSearch}>
          <IconSearch size={15} />
          <input
            type="text"
            placeholder="Search messages…"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.threadList}>
        {pagedThreads.length === 0 ? (
          <div className={styles.threadListEmpty}>No messages found.</div>
        ) : (
          pagedThreads.map((t) => (
            <ThreadItem
              key={t.id}
              thread={t}
              active={t.id === selectedThreadId}
              onClick={() => onThreadClick(t.id)}
            />
          ))
        )}
      </div>

      <div className={styles.msgPanelFooter}>
        <span className={styles.panelPageInfo}>{pageInfoText}</span>
        <div className={styles.panelPageBtns}>
          <button
            className={styles.pageBtn}
            disabled={currentPage <= 1}
            onClick={onPrevPage}
          >
            <IconChevronLeft size={14} />
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              className={`${styles.pageBtn} ${p === currentPage ? styles.pageBtnActive : ""}`}
              onClick={() => onGoPage(p)}
            >
              {p}
            </button>
          ))}
          <button
            className={styles.pageBtn}
            disabled={currentPage >= totalPages}
            onClick={onNextPage}
          >
            <IconChevronRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
